var _desc, _ellipse, _path, _path2, _ellipse2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Coins") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A solid styled icon from Orion Icon Library.")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "layer2",
    cx: 20,
    cy: 40.9,
    rx: 18,
    ry: 5.1,
    fill: "#8d8ea3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M2 46.7v4c5.3 3 14.4 3.3 18 3.3s12.7-.3 18-3.3v-4c-5.3 3-14.4 3.3-18 3.3s-12.7-.3-18-3.3zm0 8v4c5.3 3 14.4 3.3 18 3.3s12.7-.3 18-3.3v-4c-5.3 3-14.4 3.3-18 3.3s-12.7-.3-18-3.3z",
    fill: "#8d8ea3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M41.9 40.1a6 6 0 0 1 .1.8 5.6 5.6 0 0 1-1 3.2h3c3.6 0 12.7-.3 18-3.3v-4c-5.3 3-14.4 3.3-18 3.3zm.1 8v2.6a4 4 0 0 1-.3 1.4H44c3.6 0 12.7-.3 18-3.3v-4c-5.3 3-14.4 3.3-18 3.3z",
    fill: "#253858"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "layer1",
    cx: 44,
    cy: 7.1,
    rx: 18,
    ry: 5.1,
    fill: "#253858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M26 28.9v3.2c4.6.4 10.1 1.4 13.3 3.9l4.7.2c3.6 0 12.7-.3 18-3.3v-4c-5.3 3-14.4 3.3-18 3.3s-12.7-.4-18-3.3zm0-16v4c5.3 3 14.4 3.3 18 3.3s12.7-.3 18-3.3v-4c-5.3 3-14.4 3.3-18 3.3s-12.7-.4-18-3.3zm0 8v4c5.3 3 14.4 3.3 18 3.3s12.7-.3 18-3.3v-4c-5.3 3-14.4 3.3-18 3.3s-12.7-.4-18-3.3z",
    fill: "#253858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank3);
export default __webpack_public_path__ + "static/media/bank3.bf321f84ecea8be708a57c2f91a69983.svg";
export { ForwardRef as ReactComponent };